import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {/* Xeme rebrand: official tile mark works on light and dark, so no invert; the wordmark swaps ink -> paper on dark [GL 02] */}
        {icon ? (
          <img
            className={classNames("mx-auto w-9", src !== "/api/logo" && "dark:invert")}
            alt="Xeme"
            title="Xeme"
            src={`${src}?type=icon`}
          />
        ) : src === "/api/logo" ? (
          <>
            <img className={classNames(small ? "h-4 w-auto" : "h-5 w-auto", "dark:hidden")} alt="Xeme" title="Xeme" src={src} />
            <img
              className={classNames(small ? "h-4 w-auto" : "h-5 w-auto", "hidden dark:inline")}
              alt="Xeme"
              title="Xeme"
              src="/cal-logo-word-dark.svg"
            />
          </>
        ) : (
          <img
            className={classNames(small ? "h-4 w-auto" : "h-5 w-auto", "dark:invert")}
            alt="Xeme"
            title="Xeme"
            src={src}
          />
        )}
      </strong>
    </h3>
  );
}
